import { useAuthStore } from '@/stores/auth.store'

export interface DevelopmentTools {
  mockMenuOpen: () => void
  mockMenuClose: () => void
  mockPermissionsOpen: () => void
  mockPermissionsClose: () => void
}

declare global {
  interface Window {
    __dev__?: DevelopmentTools
  }
}

export function installDevGlobals(): void {
  window.__dev__ = {
    ...window.__dev__,
    mockMenuOpen: () => useAuthStore.getState().setMockMenuEnabled(true),
    mockMenuClose: () => useAuthStore.getState().setMockMenuEnabled(false),
    mockPermissionsOpen: () => useAuthStore.getState().setMockPermissionsEnabled(true),
    mockPermissionsClose: () => useAuthStore.getState().setMockPermissionsEnabled(false),
  }
}

export { default } from './DevToolsPanel'
export type { DevToolAction } from './DevToolsPanel'
